import React from 'react';
import { CheckIcon, BatteryWarningIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { heroChecks, MOCKUP_URL } from '../data/content';
export function Hero() {
  return <header className="relative w-full overflow-hidden bg-ink" data-id="element-164" data-mp="9ka2cotbuas6">
      <div className="w-full bg-volt px-4 py-2 text-center text-xs font-bold uppercase tracking-wide text-ink sm:text-sm" data-id="element-165" data-mp="9igw3ammlskp">
        For automotive technicians • Today only $27
      </div>
      <div className="mx-auto grid max-w-6xl gap-10 px-4 pb-16 pt-10 sm:px-6 lg:grid-cols-[1.05fr_1fr] lg:items-center lg:gap-12 lg:pb-24 lg:pt-16" data-id="element-166" data-mp="127eeddqu7pdg">
        <div data-id="element-167" data-mp="sai2qz5n6n4o">
          <p className="flex items-center gap-2 text-sm font-bold uppercase tracking-wide text-spark" data-id="element-168" data-mp="s9zz3hgnh6mq">
            <BatteryWarningIcon className="h-5 w-5" aria-hidden="true" data-id="element-169" data-mp="nbeyvi1eemya" />
            Mystery battery drain?
          </p>
          <h1 className="mt-3 font-display text-[54px] font-extrabold uppercase leading-[0.9] tracking-tight text-white sm:text-7xl lg:text-[84px]" data-id="element-170" data-mp="3d2tpxe128sgn">
            Stop guessing.
            <span className="block text-volt" data-id="element-171" data-mp="3j9tzsvxzjik8">Start tracing the drain.</span>
          </h1>
          <p className="mt-5 text-xl font-bold leading-snug text-white sm:text-2xl" data-id="element-172" data-mp="3o6kh1mlj0k78">
            Turn Mystery Battery Drain Problems Into a Structured 6-Step Diagnostic Workflow
          </p>
          <p className="mt-4 text-base leading-relaxed text-mist sm:text-lg" data-id="element-173" data-mp="3e8efx77jni3f">
            Find a clearer path from an unexplained dead battery to documented electrical test results —
            without randomly replacing parts or jumping between circuits.
          </p>
        </div>

        <div className="-mx-4 sm:mx-0 lg:row-span-2" data-id="element-174" data-mp="2qkdai75nwhs8">
          <img src={MOCKUP_URL} alt="Parasitic Drain Diagnostic Blueprint: 6 volumes and 5 bonus guides" className="w-full" data-id="element-175" data-mp="2qhqudj4pgtye" />
        </div>

        <div data-id="element-176" data-mp="2hjovb94j8bdr">
          <div className="rounded-2xl border border-line bg-navy p-5" data-id="element-177" data-mp="2hl9rt4aeq4e9">
            <p className="font-display text-2xl font-extrabold uppercase leading-tight text-white" data-id="element-178" data-mp="2ljh0rcymq1ew">
              Introducing the <span className="text-volt" data-id="element-179" data-mp="s3cloaja7jqk">Parasitic Drain Diagnostic Pathway™</span>
            </p>
            <p className="mt-2 text-sm text-mist sm:text-base" data-id="element-180" data-mp="na0ab23m59fr">
              A practical, step-by-step diagnostic system to organize battery drain investigations,
              evaluate vehicle sleep conditions, measure electrical draw, narrow down suspect circuits,
              and document findings.
            </p>
            <ul className="mt-4 grid gap-2.5 sm:grid-cols-2" data-id="element-181" data-mp="1ayjep6jjl22k">
              {heroChecks.map(c => <li key={c} className="flex items-start gap-2.5 text-[15px] font-semibold text-white" data-id="element-182" data-mp="112pwp7n20gde">
                  <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-ok" data-id="element-183" data-mp="x14kzpm9a84s">
                    <CheckIcon className="h-3.5 w-3.5 text-ink" strokeWidth={3.5} aria-hidden="true" data-id="element-184" data-mp="3ltgm7o0v2mna" />
                  </span>
                  {c}
                </li>)}
            </ul>
          </div>
          <div className="mt-7" data-id="element-185" data-mp="1xacfj35u5jt8">
            <CtaButton id="hero-cta" label="Get the complete blueprint — $27" sub="One-Time Payment • Instant Digital Access • 7-Day Guarantee" data-id="element-186" data-mp="1xb5o89ocuje0" />
          </div>
        </div>
      </div>
    </header>;
}